import gql from 'graphql-tag';

export const SEARCH_RELEASEDEALS = gql`
  query searchReleaseDeals ($idValue: ID!) {
    SearchReleaseDeals(id:$idValue) {
      id
    }
  }
`;

export const CREATE_RELEASEDEAL = gql`
  mutation createReleaseDeal (
    $id: ID,
    $startDate: _Neo4jDateTimeInput,
    $endDate: _Neo4jDateTimeInput,
    $commercialModelTypes: [String],
    $useTypes: [String],
    $releaseDisplayStartDate: _Neo4jDateTimeInput,
    $trackListingPreviewStartDate: _Neo4jDateTimeInput,
    $coverArtPreviewStartDate: _Neo4jDateTimeInput,
    $clipPreviewStartDate: _Neo4jDateTimeInput,
    $territoryCode: [String]
  ) {
  CreateReleaseDeal(
    id: $id,
    startDate: $startDate,
    endDate: $endDate,
    commercialModelTypes: $commercialModelTypes,
    useTypes: $useTypes,
    releaseDisplayStartDate: $releaseDisplayStartDate,
    trackListingPreviewStartDate: $trackListingPreviewStartDate,
    coverArtPreviewStartDate: $coverArtPreviewStartDate,
    clipPreviewStartDate: $clipPreviewStartDate,
    territoryCode: $territoryCode
  ) {
    id,
    startDate { formatted },
    endDate { formatted },
    commercialModelTypes,
    useTypes,
    releaseDisplayStartDate { formatted },
    trackListingPreviewStartDate { formatted },
    coverArtPreviewStartDate { formatted },
    clipPreviewStartDate { formatted },
    territoryCode
  }
}
`;

export const UPDATE_RELEASEDEAL = gql`
  mutation upateReleaseDeal (
    $id: ID!,
    $startDate: _Neo4jDateTimeInput,
    $endDate: _Neo4jDateTimeInput,
    $commercialModelTypes: [String],
    $useTypes: [String],
    $releaseDisplayStartDate: _Neo4jDateTimeInput,
    $trackListingPreviewStartDate: _Neo4jDateTimeInput,
    $coverArtPreviewStartDate: _Neo4jDateTimeInput,
    $clipPreviewStartDate: _Neo4jDateTimeInput,
    $territoryCode: [String]
  ) {
  UpdateReleaseDeal(
    id: $id,
    startDate: $startDate,
    endDate: $endDate,
    commercialModelTypes: $commercialModelTypes,
    useTypes: $useTypes,
    releaseDisplayStartDate: $releaseDisplayStartDate,
    trackListingPreviewStartDate: $trackListingPreviewStartDate,
    coverArtPreviewStartDate: $coverArtPreviewStartDate,
    clipPreviewStartDate: $clipPreviewStartDate,
    territoryCode: $territoryCode
  ) {
    id,
    startDate { formatted },
    endDate { formatted },
    commercialModelTypes,
    useTypes,
    releaseDisplayStartDate { formatted },
    trackListingPreviewStartDate { formatted },
    coverArtPreviewStartDate { formatted },
    clipPreviewStartDate { formatted },
    territoryCode
  }
}
`;

export const DELETE_RELEASEDEAL = gql`
  mutation deleteReleaseDeal (
    $id: ID!
  ) {
  DeleteReleaseDeal(
    id: $id
  ) {
    id
  }
}
`;
